//
//
//
//
//
//

export default {
  name: 'ButtonsMenu',
  props: {
    menu: {
      type: Array,
      default: () => {},
    },
    activeIndex: {
      type: Number,
      default: null,
    },
    left: {
      type: Boolean,
      default: false,
    },
    dashBoard: {
      type: Boolean,
      default: false,
    },
    owner: {
      type: Boolean,
      default: false,
    },
    lecturer: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clickfilterItem(index, value) {
      this.$emit('itemClick', index, value);
    },
  },
};
